export default {
  Providers: {
    App: 'providers.app',
    TokenLists: 'providers.tokenLists',
    Tokens: 'providers.tokens',
    Staking: 'providers.staking',
    JoinPool: 'provider.joinPool',
    ExitPool: 'provider.exitPool',
    PoolStaking: 'provider.poolStaking',
    PoolBurrStaking: 'providers.poolBurrStaking',
    UserStaking: 'provider.userStaking',
    UserData: 'provider.userData',
    UserPools: 'provider.userPools',
    UserBurrStaking: 'provider.userBurrStaking',
    UserBurrPools: 'provider.userBurrPools',
    Wallets: 'provider.wallets',
    Pool: 'provider.pool',
    UserTokens: 'provider.userTokens',
    CrossChainSync: 'provider.crossChainSync',
    Voting: 'provider.voting',
    PoolRewards: 'provider.poolRewards',
    GlobalPools: 'provider.globalPools',
    AppKit: 'provider.appkit',
  },
};
